var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCallCircleFilled = function SvgCallCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "CallCircleFilled_svg__Capa_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 28 28"
    },
    viewBox: "0 0 28 28"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".CallCircleFilled_svg__st0{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1 16.8c-.1.1-.2.1-.3.2h-.3c-.1 0-1.9-.4-3-1.5s-1.5-2.9-1.5-3v-.3c0-.1.1-.2.2-.3l.8-.9-1.7-1.7L9 10.6c0 .8.2 3.7 2.5 5.9 2.2 2.2 5.1 2.5 5.9 2.5l1.3-1.3L17 16l-.9.8z",
    className: "CallCircleFilled_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C6.3 0 0 6.3 0 14s6.3 14 14 14 14-6.3 14-14S21.7 0 14 0zm6.2 17.9c0 .1-.1.2-.1.2l-1.8 1.8c-.3.3-.6.4-.9.4-1 0-4.2-.3-6.8-2.9s-2.8-5.9-2.9-6.8c0-.4.1-.7.4-1l1.8-1.8c-.1 0 0-.1.1-.1s.2-.1.3-.1c.1 0 .2 0 .3.1.1 0 .2.1.2.1l2.7 2.7c.1.1.1.1.1.2s.1.2.1.3c0 .1 0 .2-.1.3 0 .1-.1.2-.1.2l-1.1 1.1c.1.5.5 1.4 1.1 2 .6.6 1.5.9 2 1.1l1.1-1.1c.1-.1.1-.1.2-.1s.2-.1.3-.1c.1 0 .2 0 .3.1.1 0 .2.1.2.1l2.7 2.7c.1.1.1.1.1.2s.1.2.1.3c-.2-.1-.3 0-.3.1z",
    className: "CallCircleFilled_svg__st0"
  })));
};
export default SvgCallCircleFilled;